var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Briefcase = function Briefcase(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M12 11a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 6V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h2Zm2.293-1.707A1 1 0 0 1 10 4h4a1 1 0 0 1 1 1v1H9V5a1 1 0 0 1 .293-.707ZM4 14.556V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.444a21 21 0 0 1-16 0Zm16-2.183a19 19 0 0 1-16 0V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3.373Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Briefcase;